<template>
  <f7-page class="main-order-inquiry">
    <TheNavbar
      :nav-title="$t('commercialization.common.mySalesOrders')"
      back-btn-enable
      :back-callback="callBackBtn"
    />
    <div class="container-header min-h-min">
      <div class="display-flex w-100">
        <div class="w-30 text-color-metal-tint">
          {{ `${$t('common.deliveryDateShort')}:` }}
        </div>
        <div class="text-color-metal-tint font-medium">
          {{ order.FechaEntrega ? GetDate(order.FechaEntrega) : '' }}
        </div>
      </div>
      <div class="display-flex w-100 mt-1">
        <div class="w-30 text-color-metal-tint">
          {{ `${$t('common.customer')}:` }}
        </div>
        <div class="text-color-metal-tint font-medium">
          {{ order.NombreCliente ?? '' }}
        </div>
      </div>
    </div>

    <div
      class="container-cards"
    >
      <f7-list
        class="container-cards-list"
        media-list
      >
        <f7-list-item
          v-for="(pedidos, i) in order.items"
          :key="i"
          link="#"
          class="container-cards-list__item"
          @click="SelectEntity(pedidos)"
        >
          <template #header>
            <div class="display-flex align-items-center justify-content-space-between size-16 font-medium ">
              <div class="display-flex align-items-center">
                <div
                  class="min-w-min mr-2"
                  :class="{
                    'container-cards-list__item--state-proposal': pedidos.EstadoPedido === 0,
                    'container-cards-list__item--state-firm': pedidos.EstadoPedido === 1,
                    'container-cards-list__item--state-rejected': pedidos.EstadoPedido === 2,
                    'container-cards-list__item--state-served': pedidos.EstadoPedido === 3,
                  }"
                >
                  {{ GetOrderState(pedidos.EstadoPedido).toUpperCase() }}
                </div>
                <div
                  v-if="cargandoPorentajes"
                  class="container-cards-list__item--state-pending min-w-min"
                >
                  {{ $t('common.loading') }}
                </div>

                <div
                  v-if="gerPercentage(pedidos) === 0 && !cargandoPorentajes"
                  class="container-cards-list__item--state-pending min-w-min"
                >
                  {{ $t('common.pending').toUpperCase() }}
                </div>
                <div
                  v-if=" gerPercentage(pedidos) > 0 && gerPercentage(pedidos) < 100 && !cargandoPorentajes"
                  class="container-cards-list__item--state-in-process min-w-min"
                >
                  {{ $t('common.inProcess').toUpperCase() }}
                </div>
                <div
                  v-if="gerPercentage(pedidos) === 100 && !cargandoPorentajes"
                  class="container-cards-list__item--state-finished min-w-min"
                >
                  {{ $t('common.numberCompleted').toUpperCase() }}
                </div>
              </div>
              <div v-if="gerPercentage(pedidos) !== 0">
                <div
                  class="min-w-min"
                  :class="{
                    'container-cards-list__item--state-in-process': gerPercentage(pedidos) > 0 && gerPercentage(pedidos) < 100,
                    'container-cards-list__item--state-finished': gerPercentage(pedidos) === 100,
                  }"
                >
                  {{ `${gerPercentage(pedidos)}%` }}
                </div>
              </div>
            </div>
          </template>
          <template #title>
            <div class="container-cards-list__item--order-number truncate-x2">
              {{ `Ref.${pedidos.Referencia ?? $t('commercialization.common.noReference')} - ${pedidos.Serie} / ${pedidos.Numero}` }}
            </div>
          </template>
          <template #subtitle>
            <div class="container-cards-list__item--location">
              {{ pedidos.DireccionEnvio?.Nombre ?? $t('commercialization.common.noAddress') }}
            </div>
          </template>
        </f7-list-item>
      </f7-list>
    </div>
  </f7-page>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useAppOrdersStore } from '@/js/stores/appOrders';

import TheNavbar from '@/components/TheNavbar.vue';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import { Log } from '@/js/common/HIDebuggingSupport';
import { f7 } from 'framework7-vue';
import APIErp from '@/js/services/APIErp';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'OrderInquiry',

  components: {
    TheNavbar,
  },

  props: {
    order: {
      type: Object,
      required: true,
    },
    filtros: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      reservasPedidos: [],
      cargandoPorentajes: true,
    };
  },

  computed: {
    ...mapWritableState(useAppOrdersStore, [
      'actualOrder',
      'dataClient',
      'newOrder',
      'estadoPedidoCopiado',
      'initStateOrder',
    ]),
  },

  mounted() {
    this.StartComponent();
  },

  methods: {
    async StartComponent() {
      Log(this, this.StartComponent.name);
      this.GetReservations();
    },
    async callBackBtn() {
      Log(this, this.callBackBtn.name);
      f7.views.main.router.navigate('/commercialisation/salesOrder/frmSalesOrder', {
        ignoreCache: true,
        reloadPrevious: true,
        props: {
          filtros: this.filtros,
        },
      });
      await sleep(500);
      f7.views.main.router.back();
      this.newOrder = [];
      this.actualOrder = null;
      this.dataClient = null;
      this.estadoPedidoCopiado = false;
    },
    GetDate(date) {
      Log(this, this.GetDate.name);
      return SoporteFechaYHora.ObtenerDiaMesAno(date);
    },
    assignReservationsPeroOrder() {
      Log(this, this.assignReservationsPeroOrder.name);
      this.order.items.forEach((pedido) => {
        pedido.LineasReserva = [];
        this.reservasPedidos.forEach((linea) => {
          if (pedido.Id === linea.Id_PedidoVenta) {
            pedido.LineasReserva.push(linea);
          }
        });
      });
      this.cargandoPorentajes = false;
    },
    gerPercentage(pedido) {
      Log(this, this.gerPercentage.name);

      if (pedido?.LineasReserva && Array.isArray(pedido.LineasReserva)) {
        let percent = 0;
        let cantidadEnvaseRealizadoReal = 0;
        let cantidadTotal = 0;
        pedido.LineasReserva.forEach((element) => {
          cantidadEnvaseRealizadoReal += element.CantidadEnvaseRealizadoReal;
          cantidadTotal += element.CantidadTotal;
        });
        percent = (cantidadEnvaseRealizadoReal * 100) / cantidadTotal;
        return Math.round(percent);
      }
      return 0;
    },
    GetOrderState(estadoPedido) {
      Log(this, this.GetOrderState.name);
      //   Propuesta = 0,
      //   EnFirme = 1,
      //   Rechazado = 2,
      //   Servido = 3

      switch (estadoPedido) {
        case 0:
          return this.$t('commercialization.common.orderStatus.proposed');
        case 1:
          return this.$t('commercialization.common.orderStatus.firm');
        case 2:
          return this.$t('commercialization.common.orderStatus.rejected');
        case 3:
          return this.$t('commercialization.common.orderStatus.served');
        default:
          return this.$t('commercialization.common.orderStatus.unknown');
      }
    },

    /* linea seleccionada del resumen */
    SelectEntity(item) {
      Log(this, this.SelectEntity.name);
      this.actualOrder = item;
      // this.newOrder = [{
      //   items: [item],
      //   Estado: this.$t('common.numberCompleted'),
      // }];
      this.initStateOrder = null;
      f7.views.main.router.navigate('/OrderDetail/', {
        props: {
          filtros: this.filtros,
          order: this.order,
          nuevoPedido: false,
          navbarBtn: true,
          mostrarBtnNextAdd: true,
          mostrarOnlyBtnAdd: true,
          mostrarToolbar: true,
        },
      });
    },
    async GetReservations() {
      Log(this, this.GetReservations.name);
      // HiDialog.Preloader(true, this.$t('commercialization.info.savingSalesOrder'), false);
      try {
        const ids = this.order.items.map((item) => item.Id);
        const idsConcatenated = ids.join(',');
        const result = await APIErp.callReservations(idsConcatenated);
        // HiDialog.Preloader(false);
        if (!result.data.Valor) {
          return;
        }
        this.reservasPedidos = result.data.Tag;
        this.assignReservationsPeroOrder();
      } catch {
        // HiDialog.Preloader(false);
        // HiNotification.Alert(error.response.data.Mensaje, this.$t('commercialization.info.salesOrderNotCreated'));

      }
    },
  },

};
</script>

<style lang="scss">
.main-order-inquiry {
  .page-content {
    overflow-y: hidden;
  }
  .container-navbar{
    .navbar-inner {
      .title {
          font-size: 16px;
          font-weight: 400;
      }
    }
  }
  .container-header{
    background: var(--f7-bars-bg-color);
    padding: 10px 14px 10px 14px;
    height: 70px;
    margin-top: -1px;
  }

  .container-cards{
    overflow-y: scroll;
    height: calc(100% - 130px);
    .container-cards-list {
      margin: 0px;
      &__item {
        --f7-list-item-title-line-height: 1.2;
        background-color: var(--his-mora-white);
        margin: 10px 12px 10px 12px;
        border: 1px solid var(--f7-list-item-border-color);
        border-radius: 8px;
        border-bottom: 4px solid var(--f7-list-item-border-color);

        &--state-proposal{
          padding: 2px 5px 2px 5px;
          background-color: var(--his-ajo-tint);
          color: var(--his-oliva);
          border: 1px solid var(--his-oliva);
          border-radius: 4px;
        }
        &--state-firm{
          padding: 2px 5px 2px 5px;
          background-color: var(--his-ajo-tint);
          color: var(--his-melon);
          border: 1px solid var(--his-melon);
          border-radius: 4px;
        }
        &--state-rejected{
          padding: 2px 5px 2px 5px;
          background-color: var(--his-ajo-tint);
          color: var(--his-tomate);
          border: 1px solid var(--his-tomate);
          border-radius: 4px;
        }

        &--state-served{
          padding: 2px 5px 2px 5px;
          background-color: var(--his-ajo-tint);
          color: var(--his-mandarina);
          border: 1px solid var(--his-mandarina);
          border-radius: 4px;
        }
        &--state-pending{
          padding: 3px 8px 3px 8px;
          background-color: var(--his-oliva-tint);
          color: var(--his-oliva);
          border-radius: 4px;
        }
        &--state-in-process{
          padding: 3px 8px 3px 8px;
          background-color: var(--his-banana-light);
          color: var(--his-mandarina-dark);
          border-radius: 4px;
        }
        &--state-finished{
          padding: 3px 8px 3px 8px;
          background-color: var(--his-melon-tint);
          color: var(--his-melon);
          border-radius: 4px;
        }

        &--order-number {
          font-size: 16px;
          margin-top: 12px;
        }

        &--location {
          display: flex;
          color: var(--his-berenjena-light);
          font-size: 14px;
          font-weight: 400;
          align-items: center;
          margin-top: 8px;
        }
      }
    }
  }

}
</style>
